import { FC } from 'react';
import { ENV_CONFIG } from 'config/environment';

interface Props {
  text?: string;
}

export const ScreenLoader: FC<Props> = ({ text }) => {
  return (
    <div className="screen-loader">
      <div className="screen-loader-bar">
        <img
          src={`${ENV_CONFIG().CLOUD_STORAGE.URL}/static_content/oath_logos/Oath_FullLockup_Color_DarkText.svg`}
          alt="Oath logo"
        />
      </div>
      <div className="screen-loader-content">
        <video className="screen-loader-video" playsInline autoPlay loop muted>
          <source
            src={`${ENV_CONFIG().CLOUD_STORAGE.URL}/videos/oath_loader.mp4`}
            type="video/mp4"
          />
        </video>
        {text && <span className="h4-text text-white">{text}</span>}
      </div>
    </div>
  );
};
